import React, { useEffect, useMemo } from 'react'
import {
  getSeriesQuery,
  mapToSeriesData,
  SeriesData,
} from 'app/queries/collections/series'
import useQuery from 'app/hooks/use-query'
import { useRouter } from 'solito/router'

const query = getSeriesQuery()

export const useEpisodesList = (
  series?: string,
  currentContentId?: string,
  handlePress?: (slug: string, url: string) => void
) => {
  const [activeSeason, setActiveSeason] = React.useState('')
  const [contentId, setContentId] = React.useState('')
  const [data, setData] = React.useState<SeriesData | null>(null)
  const router = useRouter()

  const params = useMemo(() => {
    return {
      collection: series,
      season: activeSeason,
      content: currentContentId,
    }
  }, [series, activeSeason, currentContentId])

  useEffect(() => {
    if (currentContentId !== contentId) {
      setContentId(currentContentId || '')
      setActiveSeason('')
    }
  }, [currentContentId, contentId])

  const { data: apiData, loading } = useQuery(query, params, mapToSeriesData, {
    enabled: !!series,
  })

  useEffect(() => {
    if (apiData) {
      setData(apiData)
    }
  }, [apiData])

  const seriesSlug = data?.collection.slug || series

  const episodes = data?.docs.map((episode) => ({
    ...episode.content,
    href: `/series/${seriesSlug}/${episode.content.slug}`,
    episodeNumber: episode.episodeNumber,
    episodePart: episode.episodePart,
    episodeName: episode.episodeName,
  }))

  const seasons = data?.collection.series.map((season) => ({
    label: season.name,
    value: season.id,
  }))

  const handleContentClick = (contentId) => {
    const content = episodes?.find((item) => item.id === contentId)

    if (handlePress) {
      handlePress(
        content?.slug || '',
        `/series/${seriesSlug}/${content?.slug || ''}`
      )
    }
  }

  return {
    title: data?.collection.name || '',
    slug: seriesSlug || '',
    episodes: episodes || [],
    seasons: seasons || [],
    activeSeason: activeSeason || data?.series,
    nextSlug: data?.next?.slug,
    previousSlug: data?.previous?.slug,
    setActiveSeason,
    handleContentClick,
    loading,
  }
}
